import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FuryAlertBoxComponent } from './alert-box.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    FuryAlertBoxComponent,
  ],
  exports: [
    FuryAlertBoxComponent
  ]
})

export class FuryAlertBoxModule {
}
